import { accountHttpApi } from "api";

export type UserDataResponseT = {
  userDetails: {
    _id: string,
    email: string,
    uid: string,
    username?: string | null,
    name?: string | null,
    address?: string | null,
    city?: string | null,
    landmark?: string | null,
    instagram?: string | null,
    phoneNumber?: string | null,
    usercode?: string | null
  }
}

export async function requestUserData() {
  const response = await accountHttpApi.makeAuthenticatedRequest<UserDataResponseT>('/users/me');
  return response.json();
}

type UpdateUserDataBodyT = Partial<{ name: string, phoneNumber: string, instagram: string, city: string, address: string, landmark: string }>

export async function updateUserData(fields: UpdateUserDataBodyT) {
  const response = await accountHttpApi.makeAuthenticatedRequest<UserDataResponseT>('/users/me', {
    method: 'PATCH',
    body: fields
  });
  return response.json();
}

